import React from 'react';

const Error500 = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-16">
      <div className="text-center max-w-2xl">
        <h1 className="text-6xl font-extrabold text-red-600">500</h1>
        <h2 className="mt-4 text-2xl font-semibold">Sunucu Hatası</h2>
        <p className="mt-3 text-gray-600">
          Üzgünüz, bir şeyler ters gitti. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin. Sorun devam ederse bizimle iletişime geçin.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <button className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700" onClick={() => window.location.reload()}>Yenile</button>
          <a href="/iletisim" className="px-4 py-2 border rounded">İletişime Geç</a>
        </div>
      </div>
    </div>
  );
};

export default Error500;




